module.exports = __webpack_public_path__ + "static/media/lca.89fdb2ea.svg";